import { Typography, Grid } from '@mui/material'
import React from 'react'
import { ProductNameProps } from './ProductName.config'

export const ProductName = (props: ProductNameProps) => {
    return (
        <Grid container direction={"column"}>
            <Grid item container spacing={1} justifyContent="center">
                {/* H1 is hidden for SEO purposes */}
                <Typography variant="h1" sx={{ display: 'none' }}>
                    {props.brandName} {props.baseModelName}
                </Typography>
                <Grid item sx={{ zIndex: 11 }}>
                    <Typography variant='customBodyStrongCondensed'>{props.brandName}</Typography>
                </Grid>
                <Grid item sx={{ zIndex: 11 }}>
                    <Typography variant='customBodyCondensed'>{props.baseModelName}</Typography>
                </Grid>
            </Grid>
            <Grid item container justifyContent="center">
                <Typography sx={{ zIndex: 11 }} variant='customBodyXsCondensed'>{props.variantModelName}</Typography>
            </Grid>
        </Grid>
    )
}
